<button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="exportMenu">
  <ng-content select="mat-icon-button-content"> </ng-content>
</button>

<mat-menu class="export-menu" #exportMenu="matMenu">
  <div class="dialog__content w-auto"><ng-content select="dialog-content"> </ng-content></div>
  <div class="dialog__btn w-auto"><ng-content select="dialog-buttons"> </ng-content></div>
</mat-menu>
